/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Embed_JobsInputs */



/**
* | output |
* | --- |
* | "Embed Jobs" |
*
* @param {Usage_Embed_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_embed_jobs = /** @type {((inputs?: Usage_Embed_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Embed_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emplois intégrés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jobs einbetten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora lavori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание заданий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajos para incrustar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入式工作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("求人情報を埋め込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एम्बेड जॉब्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Empregos incorporados")
	return /** @type {LocalizedString} */ ("Embed Jobs")
});